import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { ReceivedImagePayload } from '../../../types';
import { useSelfieMachine } from '../../context/selfie-context';
import CaptureView from './capture-view';
const Capture = () => {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.selfie.pages.capture"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  const [state, dispatch] = useSelfieMachine();
  const {
    requirement,
    hasBadConnectivity,
    isFaceDetectionEnabled
  } = state.context;
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  let t4;
  if ($[3] !== dispatch) {
    t2 = payload => dispatch({
      type: "receivedImage",
      payload
    });
    t3 = () => dispatch({
      type: "navigatedToPrev"
    });
    t4 = () => dispatch({
      type: "cameraStuck"
    });
    $[3] = dispatch;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== hasBadConnectivity || $[8] !== isFaceDetectionEnabled || $[9] !== requirement || $[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <CaptureView title={t1} requirement={requirement} hasBadConnectivity={hasBadConnectivity} autocapture={isFaceDetectionEnabled} onComplete={t2} onBack={t3} onCameraStuck={t4} />;
    $[7] = hasBadConnectivity;
    $[8] = isFaceDetectionEnabled;
    $[9] = requirement;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default Capture;
function _temp($) {
  return $.title;
}